/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  AbstractRestService,
  optimisticLockingOf,
  privilegedTokenOf,
  RestSettings,
} from '@gh/core-data';
import { cloneDeep, omit } from 'lodash';
import { Observable } from 'rxjs';
import { SystemVarsEstimatingDto } from './system-vars-estimating.dto';
import { SystemVarsEstimatingMapper } from './system-vars-estimating.mapper';

@Injectable()
export class SystemVarsEstimatingRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  get(): Observable<SystemVarsEstimatingDto> {
    return this.httpGet(`${this.bp}/system-variables/estimating`, optimisticLockingOf(SystemVarsEstimatingMapper));
  }

  update(sysVarsEstimating: SystemVarsEstimatingDto): Observable<SystemVarsEstimatingDto> {
    const requestData = <SystemVarsEstimatingDto>omit(cloneDeep(sysVarsEstimating), ['housePlan.display']);
    return this.httpPut(
      `${this.bp}/system-variables/estimating`,
      requestData,
      privilegedTokenOf(optimisticLockingOf(SystemVarsEstimatingMapper)));
  }

}
